import {
  Create,
  SimpleForm,
  TextInput,
  required,
  maxLength,
  Toolbar,
  SaveButton,
  useNotify,
  useRedirect,
  ImageInput,
  ImageField,
} from "react-admin";
import { Button } from "@mui/material";
import useAuthorize from "../hooks/useAuthorize";
import { NEWS_PORTAL_ROLES } from "./newsRoles";

const CustomToolbar = () => {
  const redirect = useRedirect();

  const handleBack = () => {
    redirect("/blogs");
  };

  return (
    <Toolbar>
      <SaveButton />
      <Button
        color="primary"
        onClick={handleBack}
        style={{ marginLeft: "10px" }}
      >
        Back
      </Button>
    </Toolbar>
  );
};

export const BlogCreate = (props: any) => {
  const notify = useNotify();
  const redirect = useRedirect();
  useAuthorize(NEWS_PORTAL_ROLES);

  const handleSubmit = async (values:any) => {
    try {
        const formData = new FormData();
        formData.append("title", values.title);
        formData.append("description", values.description.replace(/\n/g, "<br/>"));

        if (values.image && values.image.rawFile) {
            formData.append("image", values.image.rawFile);
        }

        const token = localStorage.getItem("user_authToken");
        const response = await fetch(process.env.REACT_APP_API_URL + "/blogs", {
            method: "POST",
            body: formData,
            headers: token ? { Authorization: `Bearer ${token}` } : undefined,
        });

        if (!response.ok) {
            throw new Error("Failed to create news article");
        }

        notify("News article created successfully!", { type: "success" });
        redirect("/blogs");
    } catch (error) {
        console.error("Error creating blog:", error);
        notify("Error creating news article", { type: "error" });
    }
};

const validateImageSizeAndType = (value: any): string | undefined => {
  console.log("Received value:", value);

  // Extract the actual File object
  const file = value?.rawFile;

  if (!file) {
    console.log("No file provided");
    return undefined;
  }

  console.log("Extracted file:", file);

  // File size validation (5MB limit)
  const maxSizeInBytes = 5 * 1024 * 1024;
  if (file.size > maxSizeInBytes) {
    console.log("File size exceeded");
    return "Image size should be a maximum of 5 MB";
  }

  // File type validation
  const allowedTypes = ["image/jpeg", "image/png", "image/gif", "image/svg+xml"];
  if (!allowedTypes.includes(file.type)) {
    console.log("Invalid file type");
    return "Only JPG, JPEG, PNG, GIF, or SVG files are allowed.";
  }

  return undefined;
};


  return (
    <Create {...props}>
      <SimpleForm toolbar={<CustomToolbar />} onSubmit={handleSubmit}>
        <TextInput
          source="title"
          label="Title"
          validate={required()}
          fullWidth
        />

        <TextInput
          source="description"
          label="Description"
          validate={required()}
          multiline
          fullWidth
          rows={4} // Sets the height of the input field
        />
        <ImageInput
          source="image"
          label="Related pictures"
          accept="image/*"
          validate={[required("Image is required"), validateImageSizeAndType]}
        >
          <ImageField source="src" title="title" />
        </ImageInput>
      </SimpleForm>
    </Create>
  );
};

export default BlogCreate;
